import { http } from '../http'

export const authApi = {
  async login(email: string, password: string, code?: string) {
    const { data } = await http.post('/auth/login', { email, password, code })
    return data
  },
  async logout() {
    await http.post('/auth/logout')
  },
}
